import React, { useState, useContext } from 'react';
import { Link } from 'react-router-dom';
import { AuthContext } from '../../contexts/AuthContext';
import '../../styles/NavigationBar.css';

const NavigationBar = () => {
    const { auth, logout } = useContext(AuthContext); // Access authentication state and logout function
    const [isOpen, setIsOpen] = useState(false);

    const toggleMenu = () => {
        setIsOpen(prevIsOpen => !prevIsOpen);
    };

    const closeMenu = () => {
        setIsOpen(false);
    };

    return (
        <nav className="navigation-bar">
            <Link to="/" className="logo">
                <img src={process.env.PUBLIC_URL + '/images/favicon.png'} alt="My Image" style={{ width: '100px', height: '100px' }} />
                <p style={{
                    textAlign: "center",
                    fontFamily: "Arial, sans-serif",
                    fontSize: "2rem",  // Default font size for larger screens
                    letterSpacing: "1px",
                    fontWeight: "bold",
                    margin: "20px 0",
                    textTransform: "uppercase",
                    position: "relative",
                }}>
                    <span style={{ color: "#808080", fontSize: "0.7rem", marginRight: "5px" }}>Powered by</span>
                    <span style={{ display: "inline-block" }}>
                        <span className="initial" style={{ color: "#FF6347", fontSize: "14px", textShadow: "1px 1px 2px rgba(0,0,0,0.5)", position: "absolute", top: "100%", left: "-1%" }}>V</span>
                        <span className="initial" style={{ color: "#4169E1", fontSize: "14px", textShadow: "1px 1px 2px rgba(0,0,0,0.5)", position: "absolute", top: "100%", left: "24%" }}>e</span>
                        <span className="initial" style={{ color: "#1E90FF", fontSize: "14px", textShadow: "1px 1px 2px rgba(0,0,0,0.5)", position: "absolute", top: "100%", left: "49%" }}>n</span>
                        <span className="initial" style={{ color: "#4169E1", fontSize: "15px", textShadow: "1px 1px 2px rgba(0,0,0,0.5)", position: "absolute", top: "100%", left: "74%" }}>u</span>
                        <span className="initial" style={{ color: "#FF6347", fontSize: "15px", textShadow: "1px 1px 2px rgba(0,0,0,0.5)", position: "absolute", top: "100%", left: "99%" }}>S</span>
                    </span>
                </p>

            </Link>
            <div className={`menu-icon ${isOpen ? 'open' : ''}`} onClick={toggleMenu}>
                <div className="line"></div>
                <div className="line"></div>
                <div className="line"></div>
            </div>
            <ul className={`menu ${isOpen ? 'open' : ''}`}>
                {auth ? ( // If user is authenticated, show logout option
                    <>
                        <MenuItem to="/" onClick={closeMenu}>Home</MenuItem>
                        <MenuItem to="/profile" onClick={closeMenu}>Profile</MenuItem>
                        <MenuItem to="/" onClick={() => { logout(); closeMenu(); }}>Logout</MenuItem>
                    </>
                ) : ( // If user is not authenticated, show login and signup options
                    <>
                        <MenuItem to="/" onClick={closeMenu}>Home</MenuItem>
                        <MenuItem to="/login" onClick={closeMenu}>Login</MenuItem>
                        <MenuItem to="/signup" onClick={closeMenu}>Signup</MenuItem>
                    </>
                )}
            </ul>
        </nav>
    );
};

// Extracted MenuItem component for clarity
const MenuItem = ({ to, onClick, children }) => {
    return (
        <li>
            <Link to={to} onClick={onClick}>{children}</Link>
        </li>
    );
};

export default NavigationBar;
